import { FC } from "react";
import { useTranslation } from "react-i18next";

import { PIC } from "@ryde/assets";

import { RideSelectDirectionStyled } from "./ride.styled";

export const RideSelectDirection: FC = () => {
  const { t } = useTranslation();

  return (
    <RideSelectDirectionStyled>
      <div className="ride-select-direction">
        <PIC.NoRideDirection className="ride-select-direction-icon" />
        <div className="ride-select-direction-text">
          <span className="ride-select-direction-text-highlighted">
            {t("ride.rideDirectionNotSelected")}
          </span>{" "}
          {t("ride.direction")}
        </div>
      </div>
    </RideSelectDirectionStyled>
  );
};
